export var supportedContracts = [
    { address: '0xC9c4828C98123275aC99BAE4b187b80F169ae6Ac', chainId: 1 },
    { address: '0xe3505373A9cFf68299f38942464123C8F2ED2bd3', chainId: 10 },
    { address: '0x95dCa58d7e7b66DD8A33f1d79f4cb46B09bE0Ee4', chainId: 42161 },
    { address: '0x0A0ea58E6504aA7bfFf6F3d069Bd175AbAb638ee', chainId: 8453 },
    { address: '0xB6E0d8DCc868061faAf38D3Bf00793592ff68484', chainId: 11155111 },
];
